import { Check, Phone } from "lucide-react";
import { GoogleButton } from "@/components/GoogleAuth";
import { ScanToBook } from "@/components/ScanToBook";

const PERKS = ["Book your luxury transportation", "Request service", "Get connected with Luxury Elite ATL"];

function AuthShell({ children }) {
  return (
    <div className="relative min-h-screen overflow-hidden bg-black">
      <img src="/images/brand-escalade.jpg" alt="Black Cadillac Escalade in front of the Atlanta skyline at night" className="slow-zoom absolute inset-0 h-full w-full object-cover object-[25%_center] opacity-80 lg:object-[70%_center] lg:opacity-70" />
      <div className="absolute inset-0 bg-gradient-to-t from-black via-black/60 to-black/5 lg:bg-gradient-to-r lg:from-black lg:via-black/75 lg:to-transparent" />
      <div className="relative z-10 mx-auto flex min-h-screen max-w-6xl flex-col justify-end gap-10 px-5 pb-10 pt-10 lg:flex-row lg:items-center lg:justify-between lg:px-10">
        <div className="rise lg:max-w-lg" data-testid="brand-hero">
          <img src="/images/brand-logo-full.png" alt="Luxury Elite — Executive Transportation" className="w-64 sm:w-80" data-testid="brand-hero-logo" />
          <p className="eyebrow mt-8 text-gold">Luxury is one scan away.</p>
          <h1 className="mt-3 text-4xl leading-[1.05] tracking-tight text-ivory sm:text-5xl lg:text-6xl">Atlanta, your luxury ride awaits.</h1>
          <p className="mt-4 max-w-md text-sm leading-relaxed text-mist sm:text-base">Luxury Elite ATL is now accepting bookings.</p>
          <p className="mt-2 font-display text-lg text-gold-soft">Professional. Private. Reliable.</p>
          <a href="tel:+16784867374" className="mt-6 inline-flex items-center gap-3 text-ivory hover:text-gold" data-testid="signin-booking-phone">
            <Phone className="h-4 w-4 text-gold" />
            <span className="eyebrow text-gold">Booking</span>
            <span className="font-display text-2xl tracking-wide">678-486-7374</span>
          </a>
          <ScanToBook className="mt-6 hidden w-fit lg:flex" testId="signin-scan-to-book" />
        </div>
        <div className="glass rise stagger-2 w-full rounded-3xl p-6 shadow-[0_24px_60px_rgba(0,0,0,0.55)] sm:p-8 lg:max-w-md">
          {children}
        </div>
      </div>
    </div>
  );
}

export default function SignIn() {
  return (
    <AuthShell>
      <div className="space-y-5" data-testid="signin-card">
        <h2 className="text-2xl text-ivory">Welcome to Luxury Elite</h2>
        <ul className="space-y-2 text-sm text-mist">
          {PERKS.map((p) => (
            <li key={p} className="flex items-center gap-2"><Check className="h-4 w-4 text-gold" /> {p}</li>
          ))}
        </ul>
        <GoogleButton />
        <p className="text-center text-xs text-faint">Sign in or join in one step with Google — no password needed.</p>
      </div>
    </AuthShell>
  );
}
